import React from 'react'

// Simple skeletons for each section
const WelcomeBackHeaderSkeleton = () => (
    <div className="w-full bg-cover bg-center bg-no-repeat rounded-[20px] p-[35px] h-full animate-pulse flex flex-col bg-[#7780c4]">
        <div className="flex flex-row items-center gap-[23px]">
            <div className="rounded-full bg-deepPurple w-[90px] h-[90px]" />
            <div className="flex flex-col gap-[18px]">
                <div className="h-8 w-[220px] bg-white rounded mb-2 opacity-50"></div>
                <div className="h-[50px] w-[210px] bg-highlightColor rounded-full"></div>
            </div>
        </div>
        <div className="flex w-full max-w-[374px] h-[50px] px-[20px] flex-row justify-center items-center rounded-full overflow-hidden bg-[#ECEBF8] mt-[30px]">
            <div className="flex-1 h-6  rounded"></div>
            <div className="w-6 h-6 bg-[#D9D9D9] rounded-full ml-2"></div>
        </div>
        <div className="mt-[18px] flex flex-col gap-[10px]">
            {[...Array(3)].map((_, i) => (
                <div key={i} className="flex flex-row items-center rounded-full bg-[#ECEBF8] w-full h-[60px] px-[20px] pr-[5px]">
                    <div className="h-6 w-32 bg-whiteContrast rounded mr-4 opacity-50"></div>
                    <div className="flex-1"></div>
                    <div className="w-[50px] h-[40px] bg-[#7780c4] rounded-full opacity-30"></div>
                </div>
            ))}
        </div>
    </div>
)

const DashboardAnalyticsSkeleton = () => (
    <div className="bg-white rounded-2xl min-h-[320px] h-full w-full animate-pulse flex flex-col p-9">
        <div className="h-7 w-1/2 bg-lightBG rounded mb-3 opacity-50"></div>
        <div className="h-4 w-2/3 bg-lightBG rounded mb-5 opacity-40"></div>
        <div className="flex items-center gap-4 mb-5 mt-2 ml-1">
            <div className="w-[56px] h-[56px] rounded-full bg-lightBG opacity-40"></div>
            <div className="h-4 w-1/2 bg-lightBG rounded opacity-30"></div>
        </div>
        <div className="h-5 w-1/3 bg-lightBG rounded mb-3 mt-2 opacity-40"></div>
        <div className='mt-6'>
            {[...Array(6)].map((_, i) => (
                <div key={i} className="flex items-center gap-4 mb-2">
                    <div className="w-[40px] h-[40px] rounded-full bg-lightBG opacity-40"></div>
                    <div className="h-4 w-1/3 bg-lightBG rounded opacity-30"></div>
                </div>
            ))}
        </div>
        <div className="mt-4 h-12 w-full bg-deepPurple rounded-full opacity-30"></div>
    </div>
)

const DashboardDeeperInsightSkeleton = () => (
    <div className="bg-white rounded-[20px] min-h-[220px] w-full animate-pulse flex flex-col p-8 h-full">
        <div className="h-7 w-2/3 bg-lightBG rounded mb-2 opacity-50"></div>
        <div className="h-4 w-1/2 bg-lightBG rounded mb-4 opacity-40"></div>
        {[...Array(9)].map((_, i) => (
            <div key={i} className="flex flex-row items-center justify-between border-b border-[#ECEBF8] mb-2 h-[50px] px-2">
                <div className="h-5 w-1/3 bg-lightBG rounded opacity-40"></div>
                <div className="w-8 h-8 rounded-full bg-lightBG opacity-40"></div>
            </div>
        ))}
    </div>
)

const DashboardSkeleton = () => {
    return (
        <div className="bg-[#ECEBF8] h-full flex justify-center items-center w-full">
            <div className="grid grid-cols-12 gap-[30px] w-full">
                <div className="col-span-5">
                    <WelcomeBackHeaderSkeleton />
                </div>
                <div className="col-span-4">
                    <DashboardAnalyticsSkeleton />
                </div>
                <div className="col-span-3">
                    <DashboardDeeperInsightSkeleton />
                </div>
            </div>
        </div>
    )
}

export default DashboardSkeleton
